'use client';

import { useEffect, useState } from 'react';

import { useLocalforage } from '@/hooks/use-localforage';
import { normalizeEmail } from '@/lib/email-typo';

import { EmailTypoHint } from '../ui/email-typo-hint';
import { Input } from '../ui/input';

export const USER_EMAIL_KEY = 'user-email';

export function AuthEmailInput() {
  /**
   * I attempted to use localforage and no useState, but the input cursor
   * kept getting pushed to the end of the input field.
   * It likely has to do with the update lag on useLocalforage.
   */
  const { store } = useLocalforage<[string]>([USER_EMAIL_KEY]);
  const [email, setEmail] = useState('');

  useEffect(() => {
    store &&
      (async () => {
        const email = (await store.getItem<string>(USER_EMAIL_KEY)) || '';

        email && setEmail(normalizeEmail(email));
      })();
  }, [store]);

  const saveEmail = (value: string) => {
    setEmail(value);
    store && store.setItem(USER_EMAIL_KEY, value);
  };

  return (
    <>
      <Input
        name='email'
        required
        onChange={(e: { target: { value: string; }; }) => saveEmail(normalizeEmail(e.target.value))}
        placeholder='Email'
        type='email'
        value={email || ''}
      />

      <EmailTypoHint email={email} onAccept={saveEmail} />
    </>
  );
}
